<template lang="html">
  <ul class="share-section">
    <listItem
      v-for="(item, i) in items"
      :item="item"
      :key="item.spuId"
      :index="i"
      v-on:operation="refreshData"
    ></listItem>
  </ul>
</template>

<script>
import listItem from './listItem'

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    refreshData(index) {
      // console.log(index, this.items);
      this.items.splice(index, 1)
    }
  },
  components: {
    listItem
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.share-section {
  display: block;
}
</style>
